import React, { useMemo } from "react"
import Image from "next/image"

import { OMReference } from "@apptivity-lab/firmament-node-sdk"
import "@firmament-packages/categories/extensions/CategorizableExtensions"

import { AffExpertProfile, AffLesson } from "@firmament-packages/aff"

import { AffExpertProfileMiniView } from "../AffExpertProfile"
import { CategorizableCategoryTagsView } from "@firmament-packages/categories"

const AffLessonLargeGridCell: React.FunctionComponent<{
    lesson: AffLesson,
    onClick?: (lesson: AffLesson) => void
}> = ({ lesson, onClick }) => {
    const coverImageUrl = lesson.coverPhoto?.actualObject?.preview || lesson.coverPhoto?.actualObject?.url ||
        lesson.video?.actualObject?.preview

    const expertProfile = useMemo(() => {
        const provider = lesson.provider
        if (!provider) {
            return undefined
        }

        return new OMReference(AffExpertProfile, provider.id).actualObject
    }, [lesson.provider])

    return (
        <div>
            <div className="card bg-white-900 rounded-[8px] overflow-auto shadow"
                onClick={() => onClick && onClick(lesson)}>

                <div className="relative w-full aspect-video">
                    {coverImageUrl && <Image src={coverImageUrl} alt={lesson.title} layout="fill" objectFit="cover" />}
                </div>

                <div className="card-body p-[16px]">
                    <div className="flex">
                        <span className="flex-auto text-caption2 text-black-700">
                            {lesson.createdAt.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" })}
                        </span>
                        <span className="text-caption1 text-black-900">
                            {lesson.duration} mins
                        </span>
                    </div>

                    <h3 className="mt-[8px] text-body text-black-900">{lesson.title || "Untitled"}</h3>

                    {expertProfile && <AffExpertProfileMiniView className="mt-[12px]" expertProfile={expertProfile} />}

                    <CategorizableCategoryTagsView className="mt-[16px]" subject={lesson}
                        restrictToCategoryTypes={["SUBJECT"]} />
                </div>
            </div>
        </div>
    )
}

const AffLessonCell: React.FunctionComponent<{
    variant: "LARGE_GRID",
    lesson: AffLesson,
    className?: string,
    onClick?: (lesson: AffLesson) => void
}> = ({ variant, lesson, className, onClick }) => {
    switch (variant) {
        default:
            return <div className={className}><AffLessonLargeGridCell lesson={lesson} onClick={onClick} /></div>
    }
}

export default AffLessonCell
